export default __webpack_public_path__ + "static/media/jenkins.3c0424c3.png";